/* 🤖 this file was generated by svg-to-ts */
export const matIconTabletMac: {
  name: 'tablet-mac';
  data: string;
} = {
  name: 'tablet-mac',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.5 0h-14A2.5 2.5 0 0 0 2 2.5v19A2.5 2.5 0 0 0 4.5 24h14a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"/></svg>`
};
